import { useEffect, useState } from 'react';
import { getBaseUrl } from "../Auth";

export default function useMaintenance(): boolean | null {
    const [maintenance, setMaintenance] = useState<boolean | null>(null);

    useEffect(() => {
        const checkServer = async () => {
            try {
                const response = await fetch(`${getBaseUrl()}/ping`);
                if (response.status === 200) {
                    setMaintenance(false);
                } else {
                    setMaintenance(true);
                }
            } catch (e) {
                setMaintenance(true);
            }
        };

        checkServer();
    }, []);

    return maintenance;
}